import { render, staticRenderFns } from "./null_appointments_distances.vue?vue&type=template&id=b81a0202"
import script from "./null_appointments_distances.vue?vue&type=script&lang=js"
export * from "./null_appointments_distances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports